import React from "react";
import { colors } from "sweet-web/lib/styles";

type Props = {
  size?: number;
  color?: string;
  style?: object;
};
const CrossIcon: React.FC<Props> = props => {
  const size = String(props.size) || "22";

  return (
    <span style={props.style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={props.color || colors.gray}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    </span>
  );
};

export default CrossIcon;
